<template>
  <div id="landing" :class="$mq">
    <div id="logo">
      <img src="@/assets/imgs/logo.png" />
    </div>

    <div id="trailer">
      <iframe :width="trailer_width" :height="trailer_height" src="https://www.youtube.com/embed/WqEsQixCVAA?si=O2j4WoMwsFZ57gaK" title="YouTube video player" frameborder="0"
	allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen>
      </iframe>
    </div>

    <div id="summary">
      <img class="landing_border" src="@/assets/imgs/border.png" />

      <div id="summary_container">
        <h1>A journey beyond imagination</h1>

        <p>
          From dark brooking woods haunted with spirits to vibrant hot
          deserts which nomads must traverse, <b>The Longest Tale</b> is a
          journey of wonder and imagination.
        </p>
      
        <div id="summary_buttons">
          <a href="https://store.steampowered.com/app/3507360/The_Longest_Tale/"><img id="wishlist_now" src="@/assets/imgs/wishlist-now.png" /></a>
          <a href="https://devnullprod.com/"><img id="playtest1" src="@/assets/imgs/playtesting.png" /></a>
        </div>
      </div>

      <img class="landing_border" src="@/assets/imgs/border.png" />
    </div>

    <div id="footer">
      <img class="landing_border" src="@/assets/imgs/border.png" v-if="mq_gt_xs" />

      <div id="footer_container">
        <div id="footer1" class="column">
          <img src="@/assets/imgs/logo.png" />

          <p><b>Dev Null Productions</b></p>
          <p>48 Wall Street, #1100</p>
          <p>NYC, New York 10005</p>

          <div id="copyright" v-if="mq_gt_xs">
            <p>© Copyright 2025</p>
            <p><a href="https://devnullprod.com">Dev Null Productions</a></p>
            <p>All Rights Reserved</p>
          </div>
        </div>

        <div id="footer2" class="column">
          <a href="https://devnullprod.com/">
            <img id="playtest2" src="@/assets/imgs/playtesting.png" />
          </a>

          <div id="channels_container">
            <p><b>Our channels</b></p>
            <div id="channels">
              <a href="https://instagram.com/devnullprod">
                <img src="@/assets/imgs/IG.svg" />
              </a>

              <a href="https://x.com/devnullprod">
                <img src="@/assets/imgs/X.svg" />
              </a>

              <a href="https://www.youtube.com/@devnullprod">
                <img src="@/assets/imgs/YT.svg" />
              </a>

              <a href="https://twitch.com/devnullprod">
                <img src="@/assets/imgs/Twitch.svg" />
              </a>

              <a href="https://store.steampowered.com/app/3507360/The_Longest_Tale/">
                <img src="@/assets/imgs/Steam.svg" />
              </a>

              <a href="https://www.linkedin.com/company/devnullprod">
                <img src="@/assets/imgs/linkedin.svg" />
              </a>

              <a href="https://www.facebook.com/people/Dev-Null-Prod/100063785149118/">
                <img src="@/assets/imgs/FB.svg" />
              </a>

              <a href="https://www.tiktok.com/@devnullprod">
                <img src="@/assets/imgs/TikTok.svg" />
              </a>

              <a href="https://bsky.app/profile/devnullprod.bsky.social">
                <img src="@/assets/imgs/BlueSky.svg" />
              </a>

              <a href="https://www.threads.net/@devnullprod">
                <img src="@/assets/imgs/Threads.svg" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div id="copyright" v-if="mq_xs">
      <p>© Copyright 2025</p>
      <p>Dev Null Productions</p>
      <p>All Rights Reserved</p>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'Landing',

    computed : {
      trailer_width (){
        if(this.mq_xl)
          return 1200;
        else if(this.mq_lg)
          return 992;
        else if(this.mq_md)
          return 768;
        else if(this.mq_sm)
          return 560;
        else
          return 376;
      },

      trailer_height (){
        if(this.mq_xl)
          return 675;
        else if(this.mq_lg)
          return 522;
        else if(this.mq_md)
          return 425;
        else if(this.mq_sm)
          return 315;
        else
          return 210;
      }
    }
  }
</script>

<style scoped lang="scss">
@import "@/scss/custom.scss";

a{
  color: $off-white;
}

a.disabled{
  pointer-events: none;
  cursor: default;
}

a.disabled img{
  filter: brightness(50%);
}

#landing{
  width: 100%;
  min-height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  background-color: $black;
  color: $white;
  font-family: Alliance No2;
}

.landing_border{
  width: 100%;
  height: 2px;
}

#logo{
  margin-top: 30px;
}

#logo img{
  width: 275px;
}

#trailer img{
  width: calc(100vw - 50px);
  max-width: 1600px;
  margin-top: 16px;
  margin-bottom: 16px;
}

#summary{
  width: 50%;
  flex-grow: 1;
}

#landing.xs #summary{
  flex-grow: unset;
}

#landing.md #summary{
  width: 70%;
}

#landing.sm #summary{
  width: 90%;
}

#landing.xs #summary{
  width: unset;
}

#summary_container{
  padding: 15px;
}

#summary h1{
  font-family: Trajan Pro;
  font-size: 2rem;
}

#landing.xs #summary h1{
  font-size: 1.5rem;
}

#summary p{
  font-size: 1.25rem;
  margin: auto;
}

#landing.xs #summary p{
  font-size: 0.9rem;
}

#summary_buttons{
  margin: auto;
  margin-top: 15px;
  display: flex;
  justify-content: center;
  gap: 25px;
}

#landing.xs #summary_buttons{
  flex-direction: column;
  gap: 5px;
}

#summary_buttons #buy_now{
  width: 150px;
}

#landing.xs #summary_buttons #buy_now{
  margin-bottom: 15px;
}

#summary_buttons #playtest1{
  width: 285px;
}

#footer{
  margin-top: 150px;
}

#landing.xs #footer{
  margin-top: unset;
  align-self: flex-start;
  padding-left: 15px;
  width: 100%;
}

#footer_container{
  display: flex;
  justify-content: space-around;
  text-align: left;
  padding-top: 25px;

  @media screen and (max-width: 385px) {
    justify-content: unset;
  }
}

#landing.xs #footer_container{
  padding-top: unset;
}

#footer_container p{
  margin-bottom: 0;
  font-size: 12px;
}

#footer1 img{
  width: 150px;
  position: relative;
  left: -15px;
}

#copyright{
  margin-top: 50px;
}

#landing.xs #copyright{
  margin-top: 15px;
}

#copyright p{
  margin-bottom: 0;
  text-align: left;
}

#footer2 h3{
  margin-top: 15px;
  font-size: 24px;
}

#footer2 a{
  color: $white;
}

#footer2 a:hover{
  text-decoration: none;
}

#footer2 img{
  margin-top: 25px;
}

#landing.xs #footer2 #playtest2{
  width: 185px;
}

#channels_container{
  padding: 15px;
  margin-top: 15px;
  background-image: linear-gradient(-179deg, $gray-1, $black 30%);
}

#channels{
  margin: auto;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  max-width: 175px;
  gap: 17px;
}

#landing.xs #channels{
  max-width: 155px;
}

#copyright{
  margin-bottom: 15px;
}
</style>
